import session from './session'

// The timer also runs on non-MQTT pages; wake-up checks cover suspended timers.
export function installMqttSessionExpiry (store, router) {
  let timer = null
  let expiringToken = null
  const check = () => {
    clearTimeout(timer)
    const token = store.state.user.token
    if (!token) return
    const remaining = session.expiresAt(token) - Date.now()
    if (remaining > 0) {
      timer = setTimeout(check, Math.min(remaining, 2147483647))
      return
    }
    if (expiringToken === token) return
    expiringToken = token
    // Revoke immediately, before waiting for route navigation.
    session.clear()
    Promise.resolve(store.dispatch('user/destroyUserAsync')).then(() => {
      if (store.state.user.token || router.currentRoute.path === '/login') return
      return router.replace('/login')
    }).catch(error => {
      if (error.name !== 'NavigationDuplicated') console.error('[MQTT] Session expiry cleanup failed', error)
    }).finally(() => { expiringToken = null })
  }
  const unwatch = store.watch(state => state.user.token, check, { immediate: true })
  window.addEventListener('focus', check)
  window.addEventListener('pageshow', check)
  document.addEventListener('visibilitychange', check)
  return () => {
    clearTimeout(timer)
    unwatch()
    window.removeEventListener('focus', check)
    window.removeEventListener('pageshow', check)
    document.removeEventListener('visibilitychange', check)
  }
}
